import { gql } from "@grandvisionhq/graphql";
import { emptyPaymentResponse, defaultPaymentResponse } from "./default-payment-response.js";
import { qrCodePaymentResponse } from "./qr-code-payment-response.js";
import { redirectPaymentResponse } from "./redirect-payment-response.js";
import { voucherPaymentResponse } from "./voucher-payment-response.js";
const paymentResponse = gql`
  fragment PaymentResponseFragment on PlaceOrderMutationSuccessResponse {
    orderDataToken
    paymentResponse {
      ...DefaultPaymentResponseFragment
      ...RedirectPaymentResponseFragment
      ...QrCodePaymentResponseFragment
      ...VoucherPaymentResponseFragment
      ...EmptyPaymentResponseFragment
    }
    order {
      id
      paymentMethod
      orderNumber
    }
  }
  ${qrCodePaymentResponse}
  ${redirectPaymentResponse}
  ${voucherPaymentResponse}
  ${emptyPaymentResponse}
  ${defaultPaymentResponse}
`;
export {
  paymentResponse
};
//# sourceMappingURL=payment-response.js.map
